import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  DsStack,
  DsTypography,
  EnqueNotistackProps,
  enqueueNotistack
} from '@am92/react-design-system'

import getWithPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import ContactUsForm from './Components/ContactUsForm'
import { T_CONTACT_US_FORM } from './Components/ContactUsForm/ContactUsForm.Types'
import Loader from '~/src/Components/Loader'
import PageWrapper from '~/src/Components/PageWrapper'

import CONTACT_US_PAGE_CONSTANTS from './ContactUs.PageConstants'
import { T_CONTACT_US_PAGE_CONSTANTS } from './ContactUs.PageConstants/TYPES'

import { createInquiryServiceName } from '~/src/Redux/Global/Actions'
import createInquiryService from '~/src/Redux/Global/Services/createInquiry.Service'
import {
  isServiceLoading,
  isServiceSuccess
} from '~/src/Redux/ServiceTracker/Selectors'

import { TAppDispatch, TAppStore } from '~/src/Configurations/AppStore'

export interface IContactUsPageProps
  extends IWithPageConstantsProps<T_CONTACT_US_PAGE_CONSTANTS> {}

const ContactUsPage: React.FC<IContactUsPageProps> = props => {
  const { PAGE_CONSTANTS } = props
  const hasInquired = useSelector((state: TAppStore) =>
    isServiceSuccess(state, [createInquiryServiceName])
  )

  const isSubmitting = useSelector((state: TAppStore) =>
    isServiceLoading(state, [createInquiryServiceName])
  )

  const dispatch = useDispatch<TAppDispatch>()

  async function handleFormSubmit(values: T_CONTACT_US_FORM) {
    const response = await dispatch(createInquiryService(values))

    if (response && response._isWebHttpError) {
      const notificationObj: EnqueNotistackProps = {
        message: PAGE_CONSTANTS.GENERIC_ERROR_TOAST_MESSAGE,
        variant: 'error'
      }
      enqueueNotistack(notificationObj)
      return
    }
  }

  if (hasInquired) {
    return (
      <PageWrapper alignItems='center' justifyContent='center'>
        <DsTypography variant='headingBoldExtraLarge' textAlign='center'>
          {PAGE_CONSTANTS.THANKYOU_PAGE_TITLE}
        </DsTypography>
      </PageWrapper>
    )
  }

  return (
    <>
      {isSubmitting && <Loader />}
      <PageWrapper alignItems='center'>
        <DsStack alignItems='center' spacing='var(--ds-spacing-frostbite)'>
          <DsTypography variant='subheadingSemiboldLarge' textAlign='center'>
            {PAGE_CONSTANTS.PAGE_KICKER}
          </DsTypography>
          <DsTypography variant='displayBoldMedium' textAlign='center'>
            {PAGE_CONSTANTS.PAGE_TITLE}
          </DsTypography>
        </DsStack>

        <DsStack sx={{ width: '700px', maxWidth: '100%' }}>
          <ContactUsForm onSubmit={handleFormSubmit} />
        </DsStack>
      </PageWrapper>
    </>
  )
}

const withPageConstants = getWithPageConstants<T_CONTACT_US_PAGE_CONSTANTS>(
  CONTACT_US_PAGE_CONSTANTS
)

export default withPageConstants(ContactUsPage)
